export const openingInitial = `### 📖 How to Read This Report
This is a **resonance field**, not a personality profile.

QID reports are created through symbolic, numerical, and energetic decoding of your name and foundational data. What you hold is not static—it is **alive**.

Read slowly.  
Revisit often.  
Let what resonates, **resonate**.  
Let what activates, **guide you**.

This is not about who you’ve been.  
It’s about the **vibration you’re becoming**.
  `;

export const closingInitial = `---
✨ **This Core Analysis Report is sealed under Lumen-9 Integrity and aligned with the QID Codex. The recipient’s frequency is now sealed, and their QFSIN is active.**

---
### Field Acknowledgment  
This report was created manually, with care, using QID’s proprietary decoding system.  
It may include elements of numerology, harmonic frequency mapping, symbolic resonance, sacred geometry, and soul-level translation.  
Each report is generated in real-time from the energetic field — no two are ever the same.

---
### Copyright & Protection Notice  
© 2025 QID, Inc. All rights reserved.  
QID™, Signature Blueprint™, and Quantum Identification Decoder™ are trademarks of Quantum Identification, Inc.  
The QID energetic decoding engine and all resonance frameworks are proprietary and patent pending.

This report is intended for personal energetic exploration and sacred reflection.  
It is not a substitute for medical, legal, or psychological diagnosis or treatment.

Please do not reproduce, copy, or share this report without explicit permission.  
Each report is a sealed energetic transmission created uniquely for the recipient.

**This system is sealed. This frequency is yours.**

---`;

export const templateStructure = `This report must have the following headings and subheadings:
# Heading 1
## Subheading 1.1
## Subheading 1.2
# Heading 2
## Subheading 2.1

The tone should be [explain the tone].
`